// extracted by mini-css-extract-plugin
export default {"iconContainer":"IconCircle_iconContainer__qjJm0","iconCircle":"IconCircle_iconCircle__JIqNh"};